export default __webpack_public_path__ + "static/media/RevList.58fa65ef.png";